import React from 'react';
import Drawer, { FooterSpacer } from '../../Drawer';
import Button from '../../Button';

// The frame the five edit drawers share: a right-hand panel with Cancel and
// Save pinned to the footer, as every one of MMS's is (#120).
//
// Save is never disabled here. MMS uses two disciplines on one page: its
// profile drawer leaves Save clickable and answers a bad save by keeping the
// drawer open with a sentence under the field; its Student Details drawer
// greys Save until something changes. We take the first everywhere, as the
// expense form does (#116, `entryErrors` in hooks/useExpenseEntryForm.js): a
// grey button does not say which field is at fault, and one that refuses
// does. `saving` is the only thing that stops the button, because the write is
// in flight.
export default function EditDrawer({
  open, title, saving = false, onClose, onSave, width = 560, children,
}) {
  return (
    <Drawer
      open={open}
      title={title}
      onClose={onClose}
      width={width}
      footer={(
        <>
          <Button variant="secondary" onClick={onClose}>Cancel</Button>
          <FooterSpacer />
          <Button onClick={onSave} loading={saving}>Save</Button>
        </>
      )}
    >
      {children}
    </Drawer>
  );
}
